module.exports = __webpack_public_path__ + "static/media/download.9f49adb8.svg";